import { Settings } from 'lucide-react';

export default function TherapyGuide() {
    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
            <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
            <Settings className="h-4 w-4 mr-2" />
            Therapy Guide
            </h3>
            <div className="space-y-3 text-sm">
            <div className="p-3 bg-teal-50 rounded-lg border border-teal-200">
                <p className="text-teal-700 font-medium">Alex (Pursuer)</p>
                <p className="text-teal-600 text-xs mt-1">Criticizes, demands, escalates when upset</p>
            </div>
            <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
                <p className="text-blue-700 font-medium">Jordan (Withdrawer)</p>
                <p className="text-blue-600 text-xs mt-1">Withdraws, becomes silent, defends</p>
            </div>
            <div className="p-3 bg-purple-50 rounded-lg border border-purple-200">
                <p className="text-purple-700 font-medium">Your Role</p>
                <p className="text-purple-600 text-xs mt-1">Address their concerns and break negative cycles</p>
            </div>
            </div>
        </div>
    )
}